import React from 'react'

export default function MarkDuty() {
  return (
    <div>MarkDuty</div>
  )
}
